import Breadcrumbs from "../components/Breadcrumb";
import VidyardPlayer from "../components/VidyardPlayer";
import { FooterMobile } from "../Layout/FooterMobile";
import Header from "../Layout/Header";
import Sidebar from "../Layout/Sidebar";
import k12Zonebanner from '../assets/images/siteImg/community/HeaderImage_K12Zone_Desktop-540x312-1.png';
import findFriends from '../assets/images/siteImg/community/Image_FindFriends-100x100-1.png';
import joinEvents from '../assets/images/siteImg/community/Image_JoinEvents-100x100-1.png';
import tryZone from '../assets/images/siteImg/community/ImageIcon_K12Zone-100x100-1.png';
import ButtonLink from "../components/ButtonLink";
import { useOverviewContext } from "../context/OverviewContext";
import { useLinksContext } from "../context/LinksContext";

export function K12ZoneContent() {
const {userRoleVal} = useOverviewContext();
const { k12ZoneLink } = useLinksContext();
console.log(k12ZoneLink);

const getK12ZoneLink = () => {
    try {
      if (!k12ZoneLink) {
        console.warn("K12 Zone link is missing for student role.");
        return;
      }
      const cleanUrl = k12ZoneLink.trim().replace(/^"|"$/g, ""); 
      window.open(cleanUrl, "_blank");
    } catch (error) {
      console.error("Failed to open K12 Zone link:", error);
    }
};

  
const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Community", path: "/community" },
    { label: "Hang Out in the K12 Zone" }, 
];
return (
<>
    <div className="home-layout">
        <div className="sidebar-wrapper">
        <Sidebar />
        </div>
        <div className="body-wrapper-content">
        <div className="row">
            <div className="col-12">
            <Header />
            
            <div className="main-content">
                <div className="row">
                    <div className="col-12">
                        <Breadcrumbs items={breadcrumbItems} />
                    </div>
                </div>

                <div className="wp-block-k12-section container-fluid rounded-top-corners bg-color-blue-t1-community">
                    <div className="row">
                    <div className="col-12 g-0">
                        <div className="wp-block-k12-hero">
                        <div className="row no-wrap">
                            <div className="col-sm-12 col-md-6 col-xl-6 align-self-center">
                            <h1>Hang Out in the K12 Zone</h1>
                            <p className="heading-4">
                                With K12's secure, open-world virtual campus, online school is more social than ever. There's so much to explore!*
                            </p>
                            </div>
                            <div className="col-sm-12 col-md-6 col-xl-6 justify-content-center d-flex">
                            <img
                                fetchPriority="high"
                                decoding="async"
                                width="1080"
                                height="624"
                                src={k12Zonebanner}
                                alt=""
                                className="wp-image-425 img-fluid"
                            />
                            <div className="circle-background"></div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>

                <div className="wp-block-k12-section container-fluid bg-transparent">
                    <div className="row">
                    <div className="col-12 g-0">
                        <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-4 wp-block-columns-is-layout-flex">
                            <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                                <div className="wp-block-column is-layout-flow">
                                    <div className="wp-block-k12-section container-fluid bg-transparent">
                                    <div className="row">
                                        <div className="col-12 g-0">
                                        <div className="wp-block-columns mb-3 is-layout-flex">
                                            <div className="wp-block-column is-layout-flow" style={{ flexBasis: "100px" }}>
                                            <figure className="wp-block-image size-full">
                                                <img
                                                decoding="async"
                                                width="202"
                                                height="201"
                                                src={findFriends}
                                                alt=""
                                                className="wp-image-456"
                                                />
                                            </figure>
                                            </div>
                                            <div className="wp-block-column is-layout-flow">
                                            <h3>Find Friends</h3>
                                            <p>
                                                Zones are split up by grade band so you can text and chat with classmates, play games with peers, meet with teachers, join video
                                                conference group activities, and more.
                                            </p>
                                            </div>
                                        </div>

                                        <div className="wp-block-columns mb-3 is-layout-flex">
                                            <div className="wp-block-column is-layout-flow" style={{ flexBasis: "100px" }}>
                                            <figure className="wp-block-image size-full">
                                                <img
                                                decoding="async"
                                                width="200"
                                                height="201"
                                                src={joinEvents}
                                                alt=""
                                                className="wp-image-457"
                                                />
                                            </figure>
                                            </div>
                                            <div className="wp-block-column is-layout-flow">
                                            <h3><strong>Join Events and Activities</strong></h3>
                                            <p>
                                                A lot is going on in the K12 Zone! From scavenger hunts to art competitions and school assemblies, you'll find your community here.
                                            </p>
                                            </div>
                                        </div>

                                        <div className="wp-block-k12-k12-zone-links">
                                            <div className="wp-block-columns is-layout-flex">
                                            <div className="wp-block-column is-layout-flow" style={{ flexBasis: "100px" }}>
                                                <figure className="wp-block-image size-full">
                                                <img
                                                    loading="lazy"
                                                    decoding="async"
                                                    width="200"
                                                    height="200"
                                                    src={tryZone}
                                                    alt=""
                                                    className="wp-image-458"
                                                />
                                                </figure>
                                            </div>
                                            <div className="wp-block-column is-layout-flow">
                                                <h3><strong>Try the K12 Zone for yourself!</strong></h3>
                                                <p>
                                                During the school year, explore and interact with the K12 Zone. Follow the guided prompts to learn more about the Zone or explore on your own!
                                                </p>
                                                <div className="test1 wp-block-button btn-primary">
                                                                    
                                                {userRoleVal?.toUpperCase() === "STUDENT" && k12ZoneLink && (
                                                    <button
                                                    onClick={getK12ZoneLink}
                                                    className="external-link-btn btn btn-primary"
                                                    >
                                                    Enter the K12 Zone
                                                    </button>
                                                )}
                                                
                                                {userRoleVal?.toUpperCase() == "LEARNING_COACH" && (
                                                    <ButtonLink
                                                    urlKey="K12Zone_URL"
                                                    label="Enter the Visitor Zone"
                                                    className="external-link-btn"
                                                    source="links"
                                                    target="_blank"
                                                    />
                                                )}

                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        <p>*Access may vary based on grade level.</p>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                                <div className="wp-block-k12-section container-fluid bg-color-blue-t1-community">
                                    <div className="row">
                                    <div className="col-12 g-0">
                                        <div className="wp-block-k12-video-block p-5" style={{ display: "inline" }}>
                                        <div className="row">
                                        <div style={{ display: "block", opacity: 1 }}>
                                            <VidyardPlayer uuid="5G3rQpM1nFjMDRqKHUoFUh" type="lightbox" />
                                        </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>

            </div>
        </div>
        </div>
        <FooterMobile />
    </div>
</>   
);
}